import EventEmitter from 'events';

const headerResponseEventEmitter = new EventEmitter();

export default headerResponseEventEmitter;
